import React from "react";
import styles from "./Block.module.css";
import { FORM_TYPES } from "../form-enum";
import { CustomFormDate, CustomFormNumber, CustomFormText, CustomFormTree, CustomFormBoolean } from "./components";
import { SearchModalContent } from "../../../../views/dashboards/dashboard-portfolio/portfolio-space";

export default function Block({ block, ...props }) {
	const renderFill = () => {
		switch (block.type) {
			case FORM_TYPES.BOOLEAN:
				return <CustomFormBoolean block={block} {...props} />;
			case FORM_TYPES.DATE:
			case FORM_TYPES.DATETIME:
			case FORM_TYPES.DATE_TIME:
				return <CustomFormDate block={block} {...props} />;
			case FORM_TYPES.TEXT:
			case FORM_TYPES.EMAIL:
				return <CustomFormText block={block} {...props} />;
			case FORM_TYPES.TREE:
				return <CustomFormTree block={block} {...props} />;
			case FORM_TYPES.CATEGORY:
				return <SearchModalContent block={block} {...props} />;
			case FORM_TYPES.NUMBER:
				return <CustomFormNumber block={block} {...props} />;
			default:
				break;
		}
		return null;
	};
	const { isMandatory } = block.options;
	return (
		<div className={styles.container}>
			<div className={styles.caption}>
				{block.type === FORM_TYPES.BOOLEAN && !block?.options?.subtype && renderFill()}
				<span>{!props?.hiddenLabel && block?.name}</span>
				{isMandatory && <span>*</span>}
			</div>
			{(block.type !== FORM_TYPES.BOOLEAN || block?.options?.subtype) && renderFill()}
		</div>
	);
}
